<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer006"><p class="images"></p>
</div>
<div class="Basic-Text-Frame" id="_idContainer007">
<p class="btitle"><img alt="MidnightSun_titlepage" src="Images/MidnightSun_titlepage.jpg" width="95%"/><br/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0043.vue?4a521032